/**
 * Страница открыта давно, а на сервере уже вышла новая версия: файлы со старыми хешами в имени удалены, и отложенная
 * подгрузка кода (звонок, редакторы) отвечает 404. Лечится одним обновлением страницы — не чаще раза в минуту.
 */
const KEY = 'staleBuild.reloadedAt';

export function isStaleChunkError(e: unknown): boolean {
  const text = e instanceof Error ? `${e.name} ${e.message}` : String(e);
  return /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|ChunkLoadError/i.test(text);
}

/** true — страница сейчас перезагрузится. */
export function reloadForNewVersion(now = Date.now()): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? '0');
    if (now - last < 60_000) return false;
    sessionStorage.setItem(KEY, String(now));
  } catch {
    return false;
  }
  window.location.reload();
  return true;
}
